// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2fRw0","col":"Table_col__zc1YX","fulfillmentStatus":"Table_fulfillmentStatus__1M1z5","emailCol":"Table_emailCol__FZbZv"};